'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_s_PartialFunction$$anon$1() {
  this.Rm = null;
  this.Rm = new $j_java$002elang$002e$002dObject.$c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$2) => $j_java$002elang$002e$002dObject.$m_s_None$()));
}
export { $c_s_PartialFunction$$anon$1 as $c_s_PartialFunction$$anon$1 };
$p = $c_s_PartialFunction$$anon$1.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_s_PartialFunction$$anon$1;
/** @constructor */
function $h_s_PartialFunction$$anon$1() {
}
export { $h_s_PartialFunction$$anon$1 as $h_s_PartialFunction$$anon$1 };
$h_s_PartialFunction$$anon$1.prototype = $p;
$p.b = (function() {
  return "<function1>";
});
$p.cq = (function(x$0) {
  this.wZ(x$0);
});
$p.cr = (function(x, default$1) {
  return $j_java$002elang$002e$002dObject.$f_s_PartialFunction__applyOrElse__O__F1__O(this, x, default$1);
});
$p.de = (function(x) {
  return false;
});
$p.wZ = (function(x) {
  throw new $j_java$002elang$002e$002dObject.$c_s_MatchError(x);
});
$p.j = (function(v1) {
  this.wZ(v1);
});
var $d_s_PartialFunction$$anon$1 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_s_PartialFunction$$anon$1, "scala.PartialFunction$$anon$1", ({
  rD: 1,
  o: 1,
  t: 1,
  a: 1
}));
export { $d_s_PartialFunction$$anon$1 as $d_s_PartialFunction$$anon$1 };
